<template>
	<section
		class="products__static"
		:class="[
			bgColorClass
		]"
		v-if="showStatic"
	>
		<div class="products__static-content">
			<figure class="products__static-illustration">
				<div class="media-container media-container--contain media-container--square">
					<img
						class="products__static-illustration-element"
						:src="illustrationPath"
						alt="Illustration"
						loading="eager"
					/>
				</div>
			</figure>
			<h2
				class="products__static-title"
				v-if="title"
				v-html="title"
			/>
			<div
				class="products__static-text"
				v-if="text"
				v-html="text"
			/>
			<Button
				class="products__static-button"
				level="inverted"
				type="button"
				v-if="linkText && linkUrl"
				:text="linkText"
				:href="linkUrl"
				target="_blank"
			/>
		</div>
	</section>
</template>

<script>
import Button from '@/components/Button';

export default {
	components: {
		Button,
	},
	props: {
		bgColor: {
			default: 'purple',
		},
		illustration: {
			default: 'steaming-bamboo',
		},
		title: String,
		text: String,
		linkText: String,
		linkUrl: String,
	},
	computed: {
		bgColorClass() {
			return `madamesum--bg-${this.bgColor}`;
		},
		showStatic() {
			return this.title || this.text || (this.linkText && this.linkUrl);
		},
		illustrationPath() {
			return `/files/${this.themeName}/images/illustration-${this.illustration}.svg`;
		}
	}
}
</script>

<style>

</style>
